import { environment } from 'src/environment';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ActivateAppletvService } from 'src/app/core/services/activate-appletv.service';
import { BaseService } from 'src/app/core/services/base.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { UikitService } from 'src/app/core/services/uikit.service';
import * as uikit from 'uikit';
import * as $ from 'jquery';
import { InhouseAnalyticsService } from 'src/app/core/services/inhouse-analytics.service';

@Component({
  selector: 'app-activate-tv-modal',
  templateUrl: './activate-tv-modal.component.html',
  styleUrls: ['./activate-tv-modal.component.scss', '../modal-screens.scss'],
})
export class ActivateTvModalComponent implements OnInit {

  otp: string = '';
  errorMsg;
  guest;
  back = true;
  close = false;
  homeImage: any;
  otpSuccess: boolean = false;
  @ViewChild('ngOtpInput', {static: false}) ngOtpRef!: any;
  @Output() updateTitleEvent? = new EventEmitter<string>();

  config = {
    alllowNumbersOnly: false,
    length: 5,
    isPasswordInput: false,
    disableAutoFocus: true,
    placeholder: '',
    inputStyles: {
      width: '48px',
      height: '48px'
    },
    inputClass: 'otp-input-class',
    containerClass: 'otp-container-class'
  }
  skinName = environment.skinName;
  constructor(public configService: ConfigurationService,private activateService: ActivateAppletvService, 
    public baseService: BaseService, private uikitService: UikitService, private analyticsService: InhouseAnalyticsService) {
      this.baseService.disableFormButton = false;
      uikit.util.on(document, 'beforehide', '#activate-tv-modal', ()=>{
        this.otpSuccess = false;
        this.ngOtpRef.setValue('');
        this.baseService.disableFormButton = false;
      });
    }

  ngOnInit(): void {
    this.otpSuccess = false;
  }

  changeInput(e) {
    console.log(e)
    if(e.charCode !== 32){
      this.otp = e.key;
    }  else {
      e.preventDefault();
    }
  }

  onOtpChange(otp:any) {
    this.otp = otp;
    if(this.otp.length === 5){
      /*SPI-I825:Remove focus from Input*/
      $('input').blur();
      this.baseService.disableFormButton = false;
    }
    else this.baseService.disableFormButton = true;
  }

  // triggerSuccess(){
  //   this.ngOtpRef.setValue('');
  //   uikit.modal('#activate-tv-modal').hide();
  //   uikit.modal('#success').show();
  // }
  handleOtpSubmit(){
    this.baseService.disableFormBtnFn();
    if(this.otp.length === 5){
      this.activateService.validateOTP(this.otp).subscribe((resp) => {
        if (resp.status_code === 200) {
          this.baseService.voucherValidation.next(true);
          this.errorMsg = '';
          this.otpSuccess = true;
          this.baseService.disableFormButton = false;
          this.updateTitleEvent.emit(this.configService.localeKeys?.["account.success.text"]);
          const eventObj = {
            event_type: 'Event',
            event_name: 'Activate Device',
            event_status: 'Success',
          };
          this.analyticsService.trackUserActions(eventObj);
        } else {
          this.baseService.disableFormButton = true;
          this.otpSuccess = false;
          this.errorMsg = this.configService.localeKeys?.["activate_tv.enter_activation_code.text"];
          this.uikitService.staticErrorMessage(this.errorMsg);
        }
      }, (error) => {
        this.baseService.disableFormButton = true;
        this.otpSuccess = false;
        this.errorMsg = error?.error?.error?.message;
        this.uikitService.staticErrorMessage(this.errorMsg);
        const eventObj = {
          event_type: 'Event',
          event_name: 'Activate parental Control',
          event_status: 'Failure',
          event_description: this.errorMsg
        };
        this.analyticsService.trackUserActions(eventObj);
      });
    }else{
      this.baseService.disableFormButton = true;
      this.errorMsg = this.configService.localeKeys?.["activate_tv.enter_activation_code.text"];
      this.uikitService.staticErrorMessage(this.errorMsg);
      this.otpSuccess = false;
      const eventObj = {
        event_type: 'Event',
        event_name: 'Activate parental Control',
        event_status: 'Failure',
        event_description: this.errorMsg
      };
      this.analyticsService.trackUserActions(eventObj);
    }
  }
}
